import React, { useMemo } from 'react';

import classes from './ImportBulkControls.module.scss';

export default function ImportBulkControls({
  rows,
  isImporting,
  onPublishAll,
  onUnpublishAll,
  onOpenFolderPicker,
  folderTreeContent,
}) {
  const readyRows = useMemo(
    () => rows.filter((r) => r.status === 'ready' && !r.validationError),
    [rows]
  );

  const allPublished = readyRows.length > 0 && readyRows.every((r) => r.publishNow);
  const allUnpublished = readyRows.length > 0 && readyRows.every((r) => !r.publishNow);

  return (
    <div className={classes.bulkControls}>
      <div className={classes.folderBtnWrapper}>
        <button
          type="button"
          className={classes.bulkBtn}
          disabled={isImporting}
          onClick={onOpenFolderPicker}
        >
          Set folder for all
        </button>
        {folderTreeContent}
      </div>
      <button
        type="button"
        className={classes.bulkBtn}
        disabled={isImporting || allPublished}
        onClick={onPublishAll}
      >
        Publish all
      </button>
      <button
        type="button"
        className={classes.bulkBtn}
        disabled={isImporting || allUnpublished}
        onClick={onUnpublishAll}
      >
        Unpublish all
      </button>
    </div>
  );
}
